import React from "react";
import { Link } from "react-router-dom";

const breadcrumbMyOrder = () => {
  return (
    <div className="container">
      <nav className="breadcrumb">
        <Link to="/">Home</Link> 
        <i className="fas fa-angle-right"></i> My Orders
      </nav>
    </div>
  );
};

export default breadcrumbMyOrder
